<template lang="pug">
  .flow-builder-block(@dblclick="$emit('dblclick:block', block_id)", :class="{'selected-hover': selected_block == block_id, editable: !disabled}")
    b-row.mb-3(v-if="disabled")
      b-col
        p.mb-1.text-sm.text-secondary Bloque:
          span.text-success.text-sm.ml-2.uppercase(v-if="isNew") Nuevo
        h4.mb-0(:class="name ? null : 'text-help'") {{ name || 'Bloque sin nombre' }}
      b-col(cols="auto")
        .d-flex.align-items-center
          edit-icon.hover-primary.pointer(@click="$emit('click:edit', block_id)")
    p.text-help.text-center.my-5.mx-auto.w-50(v-if="!Templates.length && !loading") No has creado templates para este bloque
    .templates-container(:id="'templates_container_' + block_id")
      .template-message-row(v-for="template in Templates", :key="template.template_id", :class="{editable: !disabled}")
        text-template(v-if="template.type === 'text'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        image-template(v-if="template.type === 'image'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        gallery-template(v-if="template.type === 'gallery'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        go-to-template(v-if="template.type === 'go_to'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        action-find-product-template(v-if="template.type === 'action_find_product'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        action-update-delivery-template(v-if="template.type === 'action_update_delivery'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        analyze-text-template(v-if="template.type === 'analyze_text'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        input-validation-template(v-if="template.type === 'input_validation' || template.type === 'input_text'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @template_connectors:change="changeTemplateConnectors(template, $event)", @delete="confirmDeleteTemplate(template)")
        note-template(v-if="template.type === 'note_template'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        label-template(v-if="template.type === 'label_template'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        llm-template(v-if="template.type === 'llm_template'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        auto-payment(v-if="template.type === 'auto_payment'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        action-edit-order-template(v-if="template.type === 'action_edit_order'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        view-template(v-if="template.type === 'view'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        save-2-info-template(v-if="template.type === 'save_info_2'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        update-user-properties-template(v-if="template.type === 'update_user_properties'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        ai-nlp-template(v-if="template.type === 'ai_nlp'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        validate-template(v-if="template.type === 'validate'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        receipt-template(v-if="template.type === 'receipt'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        show-categories-template(v-if="template.type === 'show_categories'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        compare-template(v-if="template.type === 'compare'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        create-case-template(v-if="template.type === 'create_case'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        google-calendar(v-if="template.type === 'google_calendar'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        close-case(v-if="template.type === 'close_case'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        update-case(v-if="template.type === 'update_case'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        attachment-template(v-if="template.type === 'attachment'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        action-show-products(v-if="template.type === 'action_show_products'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        unsubscribe(v-if="template.type === 'unsubscribe'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        web-search(v-if="template.type === 'web_search'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        hubspot-create(v-if="template.type === 'hubspot_create'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        hubspot-find(v-if="template.type === 'hubspot_find'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        hubspot-find-any(v-if="template.type === 'hubspot_find_any'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        hubspot-update(v-if="template.type === 'hubspot_update'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        hubspot-timeline-create(v-if="template.type === 'hubspot_timeline_create'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        search-entity(v-if="template.type === 'search_first'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        search-advanced-entity(v-if="template.type === 'search'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        save-entity(v-if="template.type === 'save_in_entity'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        edit-entity(v-if="template.type === 'edit_in_entity'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        set-nlp-list(v-if="template.type === 'set_nlp_list_context'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        register-metric(v-if="template.type === 'action_new_event'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        checkpoint(v-if="template.type === 'checkpoint'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        whatsapp-template(v-if="template.type === 'whatsapp_template'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        payment-url(v-if="template.type === 'payment_url'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        request-pay(v-if="template.type === 'request_pay'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        typing(v-if="template.type === 'send_typing_on'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        random-text(v-if="template.type === 'random_text'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        email(v-if="template.type === 'action_send_email'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        switch-bot(v-if="template.type === 'switch_bot'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        extension(v-if="template.type === 'extension'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        rule(v-if="template.type === 'rule'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        create-calendar-event(v-if="template.type === 'create_calendar_event'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        available-admins(v-if="template.type === 'available_admins'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        auth-code(v-if="template.type === 'auth_code'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        arithmetic(v-if="template.type === 'arithmetic'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        matcher(v-if="template.type === 'matcher'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        date-parse(v-if="template.type === 'date_parse'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        date-operator(v-if="template.type === 'date_operator'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        customer-feedback(v-if="template.type === 'customer_feedback'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        connectors(v-if="template.type === 'connectors'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        set-bot-image(v-if="template.type === 'set_bot_image'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        show-list(v-if="template.type === 'show_list'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        create-or-update-contact(v-if="template.type === 'create_or_update_contact'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        contact-add-platform(v-if="template.type === 'contact_add_platform'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        cross-platform(v-if="template.type === 'cross_platform'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        near-pickup-location(v-if="template.type === 'near_pickup_location'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        in-coverage-area(v-if="template.type === 'in_coverage_area'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        soap-request(v-if="template.type === 'soap_request'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        action-get-order(v-if="template.type === 'action_get_order'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        save-account-attribute-info(v-if="template.type === 'save_account_attribute_info'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        call-me(v-if="template.type === 'call_me'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
        h-t-m-l(v-if="template.type === 'html'", v-bind="template", :id="`template_${template.template_id}`", :disabled="disabled", @delete="confirmDeleteTemplate(template)")
    .templates-container.mt-4(v-show="(disabled && QuickReplies.length) || (!disabled && LastVisibleTemplate)")
      p.uppercase.text-right.text-secondary.mx-3.mb-0 Respuestas rápidas
      .mb-1.text-right(v-if="LastVisibleTemplate")
        fieldset(:disabled="disabled")
          b-form-row.justify-content-end
            b-col(md="auto")
              b-form-group.mb-2
                b-form-checkbox(v-for="(t_a, t_a_index) in LastVisibleTemplate.template.Template_Attributes", :key="'random_quick_replies_' + t_a_index", v-if="t_a.name === 'random_quick_replies'", :checked="parseBoolean(t_a.value)", @change="updateTemplateAttribute(LastVisibleTemplate.template.template_id, t_a, $event)") Mostrar aleatoriamente
            b-col(md="auto")
              b-form-group(v-for="(t_a, t_a_index) in LastVisibleTemplate.template.Template_Attributes", :key="'iterable_quick_replies' + t_a_index", v-if="t_a.name === 'iterable_quick_replies'")
                b-form-checkbox(:checked="parseBoolean(t_a.value)", @change="updateTemplateAttribute(LastVisibleTemplate.template.template_id, t_a, $event)", :state="parseBoolean(t_a.value) && LastVisibleTemplate.template.Template_Connectors.length > 1 ? false : null") Iterar respuestas
                b-form-invalid-feedback(:state="parseBoolean(t_a.value) && LastVisibleTemplate.template.Template_Connectors.length > 1 ? false : null") Se itera el primer elemento, se ignoran los demás
      .template-message-row.align-items-end.flex-column(:id="'quick_replies_' + block_id + '_' + disabled")
        quick-reply-connector(v-if="LastVisibleTemplate", v-for="(quick_reply, quick_reply_index) in QuickReplies", :key="quick_reply.template_connector_id", v-bind="quick_reply", :block_id="LastVisibleTemplate.template.block_id", :disabled="disabled", :ignored="parseBoolean(getAttribute(LastVisibleTemplate.template, 'iterable_quick_replies') ? getAttribute(LastVisibleTemplate.template, 'iterable_quick_replies').value : null) && quick_reply_index > 0")
        button-common(quick-reply, add, title="Agregar respuesta +", v-if="!disabled && LastVisibleTemplate && QuickReplies.length < 11", @click="createTemplateConnector('quick_reply')")
</template>

<script>
import QuickReply from '@/components/templates/connectors/QuickReply.vue'
import { EventBus } from '@/helpers/eventBus'
import Sortable from 'sortablejs'
import _debounce from 'lodash.debounce'
import ButtonCommon from '@/components/templates/common/Button.vue'
import { createNamespacedHelpers, mapActions } from 'vuex'

const Text = () => import('@/components/templates/Text.vue')
const Image = () => import('@/components/templates/Image.vue')
const Gallery = () => import('@/components/templates/Gallery.vue')
// actions
const GoTo = () => import('@/components/templates/GoTo.vue')
const ActionFindProduct = () => import('@/components/templates/ActionFindProduct.vue')
const ActionUpdateDelivery = () => import('@/components/templates/ActionUpdateDelivery.vue')
const AnalyzeText = () => import('@/components/templates/AnalyzeText.vue')
const InputValidation = () => import('@/components/templates/InputValidation.vue')
const Note = () => import('@/components/templates/Note.vue')
const Label = () => import('@/components/templates/Label.vue')
const LLM = () => import('@/components/templates/LLM.vue')
const ActionEditOrder = () => import('@/components/templates/ActionEditOrder.vue')
const View = () => import('@/components/templates/View.vue')
const SaveInfo2 = () => import('@/components/templates/SaveInfo2.vue')
const UpdateUserProperties = () => import('@/components/templates/UpdateUserProperties.vue')
const AINLP = () => import('@/components/templates/AINLP.vue')
const Validate = () => import('@/components/templates/Validate.vue')
const Receipt = () => import('@/components/templates/Receipt.vue')
const ShowCategories = () => import('@/components/templates/ShowCategories.vue')
const Compare = () => import('@/components/templates/Compare.vue')
const CreateCase = () => import('@/components/templates/CreateCase.vue')
const GoogleCalendar = () => import('@/components/templates/GoogleCalendar.vue')
const UpdateCase = () => import('./UpdateCase.vue')
const Attachment = () => import('@/components/templates/Attachment.vue')
const ActionShowProducts = () => import('@/components/templates/ActionShowProducts.vue')
const Unsubscribe = () => import('../templates/Unsubscribe.vue')
const WebSearch = () => import('../templates/WebSearch.vue')
const HubspotCreate = () => import('../templates/HubspotCreate.vue')
const HubspotFind = () => import('../templates/HubspotFind.vue')
const HubspotUpdate = () => import('../templates/HubspotUpdate.vue')
const HubspotTimelineCreate = () => import('../templates/HubspotTimelineCreate.vue')
const HubspotFindAny = () => import('../templates/HubspotFindAny.vue')
const SearchEntity = () => import('../templates/SearchEntity.vue')
const SearchAdvancedEntity = () => import('../templates/SearchAdvancedEntity.vue')
const EditEntity = () => import('../templates/EditEntity.vue')
const SetNLPListContext = () => import('../templates/SetNLPListContext.vue')
const SaveEntity = () => import('../templates/SaveEntity.vue')
const RegisterMetric = () => import('../templates/RegisterMetric.vue')
const Checkpoint = () => import('../templates/Checkpoint.vue')
const WhatsappTemplate = () => import('../templates/WhatsappTemplate.vue')
const PaymentURL = () => import('../templates/PaymentURL.vue')
const RequestPay = () => import('../templates/RequestPay.vue')
const Typing = () => import('../templates/Typing.vue')
const RandomText = () => import('../templates/RandomText.vue')
const Email = () => import('../templates/Email.vue')
const SwitchBot = () => import('../templates/SwitchBot.vue')
const Extension = () => import('../templates/Extension.vue')
const Rule = () => import('../templates/Rule.vue')
const CreateCalendarEvent = () => import('../templates/CreateCalendarEvent.vue')
const AvailableAdmins = () => import('../templates/AvailableAdmins.vue')
const AuthCode = () => import('../templates/AuthCode.vue')
const Arithmetic = () => import('../templates/Arithmetic.vue')
const Matcher = () => import('../templates/Matcher.vue')
const DateParse = () => import('../templates/DateParse.vue')
const DateOperator = () => import('../templates/DateOperator.vue')
const CloseCase = () => import('../templates/CloseCase.vue')
const CustomerFeedback = () => import('../templates/CustomerFeedback.vue')
const Connectors = () => import('../templates/Connectors.vue')
const SetBotImage = () => import('../templates/SetBotImage.vue')
const ShowList = () => import('../templates/ShowList.vue')
const CreateOrUpdateContact = () => import('../templates/CreateOrUpdateContact.vue')
const ContactAddPlatform = () => import('../templates/ContactAddPlatform.vue')
const CrossPlatform = () => import('../templates/CrossPlatform.vue')
const NearPickupLocation = () => import('../templates/NearPickupLocation.vue')
const InCoverageArea = () => import('../templates/InCoverageArea.vue')
const SoapRequest = () => import('../templates/SoapRequest.vue')
const ActionGetOrder = () => import('../templates/ActionGetOrder.vue')
const SaveAccountAttributeInfo = () => import('../templates/SaveAccountAttributeInfo.vue')
const CallMe = () => import('../templates/CallMe.vue')
const HTML = () => import('../templates/HTML.vue')
const AutoPayment = () => import('../templates/AutoPayment.vue')

const blockController = createNamespacedHelpers('block')
const accountController = createNamespacedHelpers('account')
const platformController = createNamespacedHelpers('platform')

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    block_id: {
      default: ''
    },
    Templates: {
      type: Array,
      default: function () {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: true
    },
    isNew: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  components: {
    'text-template': Text,
    'image-template': Image,
    'quick-reply-connector': QuickReply,
    'gallery-template': Gallery,
    'go-to-template': GoTo,
    'action-find-product-template': ActionFindProduct,
    'action-update-delivery-template': ActionUpdateDelivery,
    'analyze-text-template': AnalyzeText,
    'input-validation-template': InputValidation,
    'note-template': Note,
    'label-template': Label,
    'llm-template': LLM,
    'action-edit-order-template': ActionEditOrder,
    'view-template': View,
    'save-2-info-template': SaveInfo2,
    'update-user-properties-template': UpdateUserProperties,
    'ai-nlp-template': AINLP,
    'validate-template': Validate,
    'receipt-template': Receipt,
    'show-categories-template': ShowCategories,
    'compare-template': Compare,
    ButtonCommon,
    'create-case-template': CreateCase,
    'google-calendar': GoogleCalendar,
    CloseCase,
    UpdateCase,
    'attachment-template': Attachment,
    'action-show-products': ActionShowProducts,
    'unsubscribe': Unsubscribe,
    WebSearch,
    HubspotCreate,
    HubspotFind,
    HubspotUpdate,
    HubspotTimelineCreate,
    HubspotFindAny,
    SearchEntity,
    SearchAdvancedEntity,
    SaveEntity,
    EditEntity,
    'set-nlp-list': SetNLPListContext,
    RegisterMetric,
    Checkpoint,
    WhatsappTemplate,
    'payment-url': PaymentURL,
    RequestPay,
    Typing,
    RandomText,
    Email,
    SwitchBot,
    Extension,
    Rule,
    CreateCalendarEvent,
    AvailableAdmins,
    AuthCode,
    Arithmetic,
    Matcher,
    DateParse,
    DateOperator,
    CustomerFeedback,
    Connectors,
    SetBotImage,
    ShowList,
    CreateOrUpdateContact,
    ContactAddPlatform,
    CrossPlatform,
    NearPickupLocation,
    InCoverageArea,
    SoapRequest,
    ActionGetOrder,
    SaveAccountAttributeInfo,
    CallMe,
    HTML,
    "auto-payment":AutoPayment
  },
  computed: {
    ...accountController.mapGetters(['selectedLanguage', 'selectedLocale', 'selectedLanguageName']),
    ...blockController.mapState({
      selected_block: state => state.selected_block
    }),
    ...platformController.mapState({
      platforms: state => state.platforms
    }),
    LastVisibleTemplate () {
      try {
        // return quick replies from the last visible/valid template
        for (let i = this.Templates.length - 1; i > -1; i--) {
          let template = this.Templates[i],
              type = template.type

          switch (type) {
            case 'gallery':
            case 'text':
            case 'image':
            case 'view':
            case 'random_text':
            case 'attachment':
            case 'show_categories':
            case 'action_show_products':
            case 'call_me':
              return {
                template: template,
                quick_replies: template.Template_Connectors.filter(t_c => t_c.type === 'quick_reply')
              }
          }
        }

        return null
      } catch (e) {
        console.error(e.message)
        return null
      }
    },
    QuickReplies () {
      return this.LastVisibleTemplate ? this.LastVisibleTemplate.quick_replies : []
    }
  },
  methods: {
    parseBoolean (value) {
      return value != undefined ? (value === 1 || value === '1' || value === true || value === 'true') : false
    },
    ...mapActions([
      'template_connector/create',
      'template_connector/destroy',
      'block/sortTemplates',
      'template/create',
      'template/destroy',
      'template_attribute/update',
      'account_attribute/all',
      'user_attribute/all'
    ]),
    getUserAttributes () {
      this['user_attribute/all']({
        account_id: this.$route.params.account_id,
        callback: res => {

        }
      })
    },
    getAccountAttributes () {
      this['account_attribute/all']({
        account_id: this.$route.params.account_id,
        callback: res => {

        }
      })
    },
    createConnector (blockId, templateId, connector) {
      const self = this

      this['template_connector/create']({
        language_id: self.selectedLanguage,
        template_id: templateId,
        block_id: blockId,
        ...connector,
        callback: async (res) => {
          if (res.error) {
            const res = await this.$bvModal.msgBoxConfirm('Ocurrió un error creando conector. ¿Deseas intentarlo de nuevo?', {
              title: 'Error creando',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res) return this.createConnector.apply(this, arguments)
          }
        }
      })
    },
    replaceTemplate (newTemplate, replaceTemplateId) {
      let index = this.Templates.findIndex(t => t.template_id == replaceTemplateId)

      this.deleteTemplate(this.Templates[index], done => {
        this.createTemplate(newTemplate, index)
      })
    },
    createTemplate (template, index) {
      let self = this

      this['template/create']({
        language_id: self.selectedLanguage,
        block_id: self.block_id,
        ...template,
        index: index,
        callback: async (res) => {
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error creando template. ¿Deseas intentarlo de nuevo?', {
              title: 'Error creando',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res) {
              this.createTemplate.apply(this, arguments)
            }
          }
        }
      })
    },
    async confirmDeleteTemplate (template) {
      try {
        let res = await this.$bvModal.msgBoxConfirm('¿Deseas eliminar este template? No se puede deshacer.', {
          title: 'Eliminar template',
          okVariant: 'primary',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'secondary',
          hideHeaderClose: false
        })

        if (res) {
          this.deleteTemplate.apply(this, arguments)
        }
      } catch (error) {

      }
    },
    deleteTemplate (template, callback) {
      let self = this

      this['template/destroy']({
        language_id: self.selectedLanguage,
        block_id: self.block_id,
        ...template,
        callback: async (res) => {
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error eliminando template. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de borrado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res) {
              this.deleteTemplate.apply(this, arguments)
            }
          } else {
            let index = this.Templates.findIndex(el => el.template_id == template.template_id)
            if(index >= 0) {
              this.Templates.splice(index, 1)
            }
            if (callback) callback()
          }
        }
      })
    },
    getAttribute (template, attribute_name) {
      let attribute = template.Template_Attributes.find(template_attribute => template_attribute.name === attribute_name)
      return attribute
    },
    updateAttribute (template_id, template_attribute) {
      let self = this

      this['template_attribute/update']({
        account_id: self.$route.params.account_id,
        language_id: self.selectedLanguage,
        block_id: self.block_id,
        template_id: template_id,
        ...template_attribute,
        callback: async (res) => {
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error guardando template. ¿Deseas intentarlo de nuevo?', {
              title: 'Error de guardado',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res) {
              this.updateAttribute.apply(this, arguments)
            }
          }
        }
      })
    },
    async changeTemplateConnectors(template, newConnectors) {
      const oldConnectors = [...template.Template_Connectors]

      template.Template_Connectors = []

      this.$nextTick(async () => {
        for (const connector of oldConnectors) {
          if (!connector) return

          await this.destroyConnector(connector)
        }
      })

      this.$nextTick(async () => {
        setTimeout(async () => {
          await this.putNewConnectors(newConnectors, template)
        }, 200)
      })
    },
    async putNewConnectors(connectors, template) {
      const self = this

      for (let i = 0; i < connectors.length; i++) {
        const templateConnector = {
          next_block_id: self.block_id,
          template_id: template.template_id,
          language_id: self.selectedLanguage,
          title: '',
          type: connectors[i],
          number: i + 1
        }

        this.$nextTick(() => {
          this.createBasicConnector(templateConnector).then(() => {})
        })
      }
    },
    createBasicConnector (templateConnector) {
      const self = this

      return new Promise(resolve => {
        this['template_connector/create']({
          ...templateConnector,
          callback: async (res) => {
            if (res.error) self.$message.warning('Error creando conector')

            return resolve(true)
          }
        })
      })
    },
    destroyConnector (templateConnector) {
      return new Promise(resolve => {
        this['template_connector/destroy']({
          ...templateConnector,
          callback: async (res) => {
            if (res.error) return resolve(false)

            return resolve(true)
          }
        })
      })
    }
  },
  created () {
    this.createTemplateConnector = _debounce((type) => {
      let connector = {
        title: '',
        type: type || 'payload',
        number: this.LastVisibleTemplate.template.Template_Connectors.filter(c => c.type === (type || 'payload')).length + 1
      }

      this.createConnector(this.block_id, this.LastVisibleTemplate.template.template_id, connector)
    }, 0, {leading: false, trailing: true})

    this.updateTemplateAttribute = _debounce((template_id, template_attribute, value) => {
      let attribute = JSON.parse(JSON.stringify(template_attribute))
      attribute.value = value
      this.updateAttribute(template_id, attribute)
    }, 2000, {leading: false, trailing: true})
  },
  mounted () {
    let self = this

    this.getUserAttributes()
    this.getAccountAttributes()

    if (!this.disabled) {
      var el = document.getElementById('templates_container_' + this.block_id)
      var sortable = new Sortable(el, {
        handle: '.template-tool-move',
        draggable: '.template-message-row',
        direction: 'vertical',
        ghostClass: 'draggable-ghost-class',
        filter: '.not-draggable',
        onMove: function (event) {
          return event.related.className.indexOf('no-sortable') === -1;
        },
        onEnd: function (event) {
          let oldIndex = event.oldIndex
          let newIndex = event.newIndex

          self.$store.commit('block/reorderBlocksTemplates', {
            block_id: self.block_id,
            oldIndex: oldIndex,
            newIndex: newIndex
          })
        }
      })

      // quick replies sortable
      var el = document.getElementById('quick_replies_' + this.block_id + '_' + this.disabled)
      var sortable = new Sortable(el, {
        handle: '.template-connector-tool-move',
        draggable: '.flow-builder-connector-quick-reply',
        direction: 'vertical',
        ghostClass: 'draggable-ghost-class',
        filter: '.not-draggable',
        onMove: function (event) {
          return event.related.className.indexOf('no-sortable') === -1;
        },
        onEnd: function (event) {
          let oldIndex = event.oldIndex
          let newIndex = event.newIndex

          self.$store.commit('block/reorderTemplateConnectors', {
            block_id: self.block_id,
            template_id: self.LastVisibleTemplate.template.template_id,
            oldIndex: oldIndex,
            newIndex: newIndex,
            quickReplies: true
          })
        }
      })
    }
  },
  watch: {
    QuickReplies (newValue, oldValue) {
      if (this.disabled) {
        let newIds = newValue.map(tc => tc.template_connector_id)
        let oldIds = oldValue.map(tc => tc.template_connector_id)

        // delete deleted endpoints
        oldIds.diff(newIds).forEach(template_connector_id => {
          EventBus.$emit('jsplumb:destroyEndpoint', `template_connector_${template_connector_id}`)
        })

        // create endpoints for new
        EventBus.$emit('jsplumb:create&ConnectTemplateConnectorEndpoint', newValue.filter(t => newIds.diff(oldIds).includes(t.template_connector_id)))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/colors.scss';
$block-border-radius: 1rem;

.flow-builder-block {
  color: $dark;
  width: 100%;
  height: auto;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1;

  &:not(.editable) {
    position: absolute;
    padding: 1rem;
    border: 1px solid $secondary;
    border-radius: $block-border-radius;
    cursor: grab;
    width: 500px;

    &:hover, &.jtk-drag-hover, &.selected-hover {
      border: 1px solid $primary;
    }
  }

  .templates-container {
    margin-top: 1rem;

    &:not(:last-child) {
      margin-bottom: 1rem;
    }

    .template-message-row {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      width: 100%;
      max-width: 100%;
      white-space: nowrap;
      // overflow: hidden;

      &.editable {
        overflow-x: auto;
        padding-left: 40px;
      }

      &:not(:last-child) {
        margin-bottom: 1rem;
      }

      &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: rgba(158, 165, 171, 0.2);
      }
    }
  }
}
</style>
